import { portalFetch } from '../../shared/auth/portalSession';
import { getAuthHeaders, requireAuthentication } from './authUtils';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface ServiceApiResponse {
  service_id: string;
  service_name: string;
  supported_days: string[];
  supported_providers: string[];
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface Service {
  service_id: string;
  name: string;
  availableDays: string[];
  isActive: boolean;
}

export async function getServicesApi(date?: string): Promise<Service[]> {
  requireAuthentication();
  
  try {
    let url = `${API_BASE_URL}/services`;
    if (date) {
      url += `?date=${date}`;
    }
    
    const response = await portalFetch('admin', url, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch services: ${response.statusText}`);
    }

    const data: { services: ServiceApiResponse[]; count: number } = await response.json();
    return data.services.map(s => ({
      service_id: s.service_id,
      name: s.service_name,
      availableDays: s.supported_days,
      isActive: s.is_active,
    }));
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
}
